__turbopack_context__.v({
  "active": "OtpCodeInput-module__6bDItG__active",
  "blink": "OtpCodeInput-module__6bDItG__blink",
  "caret": "OtpCodeInput-module__6bDItG__caret",
  "disabled": "OtpCodeInput-module__6bDItG__disabled",
  "filled": "OtpCodeInput-module__6bDItG__filled",
  "group": "OtpCodeInput-module__6bDItG__group",
  "invalid": "OtpCodeInput-module__6bDItG__invalid",
  "otp": "OtpCodeInput-module__6bDItG__otp",
  "pop": "OtpCodeInput-module__6bDItG__pop",
  "separator": "OtpCodeInput-module__6bDItG__separator",
  "slot": "OtpCodeInput-module__6bDItG__slot",
});
